import React from "react";
import { redirectToUrl } from "../../Utils/StayUpToDate/RenderComponent";
import { BsHourglassSplit, BsPinAngleFill } from "react-icons/bs";
import Card from "react-bootstrap/esm/Card";
import EllipsisTooltipText from "../ProductName/EllipsisTooltipText";
import ProductName from "../ProductName/ProductName";
import IndividualYoutubePostTag from "../StayUpToDateComponent/StayUpToDateIndividuelComponent/IndividualYoutubePostTag";
import { convertToWebP, preserveBrokenImageBox } from "../../Utils/imageUtils";
import { isLikelyVideoUrl } from "../../Utils/media/feedMedia";
import { useTemplateMediaReveal } from "../../Screens/DashboardView/MasterTemplateEditor/useTemplateMediaReveal";
import "../../Screens/DashboardView/MasterTemplateEditor/templateMediaReveal.css";
import ProductBankImageFrame from "../ProductBank/ProductBankImageFrame";
import { shouldUseProductImageFrame } from "../../Utils/productImage/productImageDisplay";
import "./ShopCardAlignment.css";

const ImagePostTagLocal = React.memo((props: any) => {
  const {
    data,
    isLinks,
    isPodcast,
    brand_color,
    component,
    content_shape,
    isYoutube,
    designTokens,
    pinnedPostIds,
    type,
    from,
    mediaIndex,
    isDashboard,
    source,
  } = props;

  const { thumbnail, media_url, caption, permalink } = data;
  const isTemplateSite = from === "website-template";
  const imageSrc = media_url
    ? convertToWebP(isLikelyVideoUrl(media_url) ? thumbnail : media_url)
    : "";

  const {
    setRef,
    activeSrc,
    onLoad,
    onError,
    wrapperClassName: revealClass,
  } = useTemplateMediaReveal({
    enabled: isTemplateSite && Boolean(imageSrc),
    src: imageSrc,
    index: typeof mediaIndex === "number" ? mediaIndex : undefined,
    priority: typeof mediaIndex === "number" ? mediaIndex < 6 : false,
  });

  const redirectUrl: any = redirectToUrl(data, isLinks);
  const permalinkUrl: any = data?.permalink || redirectUrl;
  const isSquare = component?.content_shape == "sq" || content_shape == "sq";
  const isPinned = Array.isArray(pinnedPostIds)
    ? pinnedPostIds.includes(data?.post_id)
    : false;
  const useProductFrame = shouldUseProductImageFrame(type, data);

  const isDefaultTemplate = designTokens?.templateName?.toLowerCase() === "default" ;

  const renderPinnedBadge = () =>
    isPinned && source !== "edit" ? (
      <div className="pinned-badge" aria-label="Pinned post" style={{right:"4px"}}>
        <BsPinAngleFill />
      </div>
    ) : null;

  const getWrapperClassName = () => {
    if (isPodcast) {
      const classes = ["creator-feed-image-wrapper-pod"];
      if (isSquare) classes.push("square-wrapper");
      if (revealClass) classes.push(revealClass);
      return classes.join(" ");
    }

    const classes = ["creator-feed-image-wrapper-links-subcomponents"];
    if (isSquare) classes.push("square-wrapper");
    else if (isYoutube) classes.push("youtube-feed-wrapper");
    if (revealClass) classes.push(revealClass);
    return classes.join(" ");
  };

  const templateMediaBg = isTemplateSite
    ? "transparent"
    : designTokens?.templateName === "Default"
      ? "#f1f1f1"
      : designTokens?.primaryColor || "#f1f1f1";

  const templateImgBg = isTemplateSite
    ? "transparent"
    : designTokens?.primaryColor || brand_color;

  const getImageClassName = () => {
    if (isPodcast) {
      const classes = ["creator-feed-image-wrapper-podcast"];
      if (isSquare) classes.push("square-image");
      return classes.join(" ");
    }

    const classes = ["creator-feed-card-links-image-subcomponents"];
    if (isSquare) classes.push("square-image");
    else if (isYoutube) classes.push("youtube-feed-height");
    return classes.join(" ");
  };

  if (data?.platform === "youtube" && !data?.product_image) {
    return (
      <IndividualYoutubePostTag
        link={data}
        handleRedirect={() => {
          const { permalink, shop_link, table_url } = data;
          const url = permalink || shop_link || table_url;
          if (url) window.open(url, "_blank");
        }}
        bgColor={brand_color}
        contentShape={content_shape}
        redirectUrl={redirectUrl}
        source={source}
        pinnedPostIds={pinnedPostIds}
        designTokens={designTokens}
      />
    );
  }

  const imgSrc = isTemplateSite ? activeSrc : imageSrc;

  return (
    <a
      href={permalinkUrl}
      target="_blank"
      className={isPodcast ? "podcast-carousel-item" : undefined}
      style={{
        textDecoration: "none",
        display: "block",
        position: "relative",
      }}
      rel="noopener noreferrer"
    >
      {renderPinnedBadge()}
      {!media_url ? (
        <div className="creator-feed-card-links-subcomponents not-available">
          <BsHourglassSplit className="hourglassSplit" />
          <p>Work in progress: This content will be available in a few minutes.</p>
        </div>
      ) : isPodcast ? (
        <div className="creator-feed-card-container">
          <div
            ref={setRef as React.Ref<HTMLDivElement>}
            className={getWrapperClassName()}
            style={{
              backgroundColor: isTemplateSite
                ? templateMediaBg
                : designTokens?.templateName === "Default"
                  ? "#f1f1f1"
                  : designTokens?.forthColor || "#f1f1f1",
              border: isTemplateSite
                ? (designTokens?.secondaryColor
                    ? `1px solid ${designTokens.secondaryColor}`
                    : undefined)
                : isDefaultTemplate
                  ? `1px solid ${designTokens.tertiaryColor}`
                : "",
              marginRight: "0px",
            }}
          >
            <div className={getImageClassName()}>
              {imgSrc ? (
                <Card.Img
                  variant="top"
                  src={imgSrc}
                  style={
                    isSquare
                      ? {
                          width: "80px !important",
                          height: "80px",
                          borderRadius: "4px",
                          backgroundColor: templateImgBg,
                        }
                      : {
                          height: "55%",
                          backgroundColor: templateImgBg,
                        }
                  }
                  loading="lazy"
                  decoding="async"
                  onLoad={onLoad}
                  onError={onError}
                  className={`creator-feed-card-podcast-image ${
                    isSquare ? "podcast-image" : ""
                  }`}
                />
              ) : null}
              <EllipsisTooltipText
                className={`caption text-center ${isSquare ? "podcast-text-square" : "podcast-text-rectangle"
                  }`}
                text={caption}
                  style={{fontFamily:designTokens?.secondaryFontFamily }}
              />
            </div>
          </div>
          {type && (
            <div className="podcast-product-name-wrapper">
              <ProductName type={type} post={data} designTokens={designTokens} />
            </div>
          )}
        </div>
      ) : (
        <div
          ref={isTemplateSite ? (setRef as React.Ref<HTMLDivElement>) : undefined}
          className={getWrapperClassName()}
        >
          {useProductFrame ? (
            <ProductBankImageFrame
              src={convertToWebP(
                isLikelyVideoUrl(media_url) ? thumbnail : media_url,
              )}
              alt="post"
              fill
              shape={content_shape || component?.content_shape}
              square={isSquare}
              loading="eager"
              onError={isTemplateSite ? onError : preserveBrokenImageBox}
            />
          ) : imgSrc ? (
            <Card.Img
              variant="top"
              src={imgSrc}
              className={getImageClassName()}
              loading={isTemplateSite ? "lazy" : "eager"}
              decoding="async"
              onLoad={isTemplateSite ? onLoad : undefined}
              onError={isTemplateSite ? onError : preserveBrokenImageBox}
              style={{
                backgroundColor: isTemplateSite
                  ? templateImgBg
                  : designTokens?.primaryColor || brand_color,
                border: designTokens?.secondaryColor ? "none" : "",
                boxShadow:
                  isTemplateSite || !brand_color
                    ? ""
                    : `0px 0.325rem 0px 0px ${brand_color}`,
              }}
            />
          ) : null}
        </div>
      )}
    </a>
  );
});

export default ImagePostTagLocal;
